<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div class="pageHeader row align-items-center" v-if="$auth.isAuthenticated">
        <div class="col-3 pageHeaderTitle">Virtual Nursing</div>
        <div class="col text-right">
          <div class="filterWrapper">
            <div class="filterText">Tenant :</div>
            <div class="dropdown col p-0">
              <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
                            placeholder="Select Tenant" @input="validateSelection" class="tenantList">
              </model-select>
              <!-- <select style="background: transparent; color: #fff; border: 0" id="tenantopt" v-model="lastSelectedTenant"
                @change="fetchTenants(); taskType();">
                <option v-for="option in tenants" v-bind:key="option.value" :value="option.value">
                  {{ option.text ? option.text : option.value }}
                </option>
              </select> -->
            </div>
          </div>

          <button class="btn btn-primary" style="margin-left: 10px" @click="updateTask($event)" :disabled="!tenantOpt">
            Update
          </button>
          <button class="btn btn-primary" style="margin-left: 10px" @click.prevent="showTaskType($event)"
                  :disabled="!tenantOpt">
            Add Task Type
          </button>
          <button class="btn btn-primary" style="margin-left: 10px" @click.prevent="showStatusModel($event)"
                  :disabled="!tenantOpt">
            Add Status
          </button>
        </div>
      </div>
      <span><h3>Task Type - [{{ tenantOpt }}] - [{{ selectedTask && selectedTask.name }}]</h3>
        <h6 style="padding-left: 20px; padding-top: 5px">Any updates to Task Type, please click on pen icon in Actions column. Only limits can be updated on this screen.</h6></span>
      <div class="row" style="justify-content: space-evenly">
        <div :class="selectedTask == null
          ? 'pageDataWrapper pageActualDataWrapper col-12'
          : 'pageDataWrapper pageActualDataWrapper col-10'
          ">
          <div class="contentHeader row m-0 align-items-center">
            <div class="col">Name</div>
            <div class="col flex-3">Is Active</div>
            <div class="col">Task hidden for DropIn</div>
            <div class="col">Can Create On Trigger</div>
            <div class="col">For Orphaned Task</div>
            <div class="col">Trigger Success Message</div>
            <div class="col">Allowed Transitions</div>
            <div class="col">Allowed Merge To</div>
            <div class="col col-2">Trigger</div>
            <div class="col col-1">Actions</div>
          </div>
          <div class="contentDataWrap" style="overflow-x: auto">
            <div v-for="(task, index) in taskTyp" v-bind:key="task.name">
              <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
                <div class="contentData row m-0 align-items-center col-12 p-0" @click="
                  onTaskTypeRowClicked($event, task);
                toggleSelectedRow(index);
                " :class="{ 'table-primary': selectedRow === index }">
                  <div class="col">{{ task.name }}</div>
                  <div class="col flex-2">
                    <input type="checkbox" v-model="task.isActive" disabled />
                  </div>
                  <div class="col">
                    <input type="checkbox" v-model="task.hideInDropin" disabled />
                  </div>
                  <div class="col">
                    <input type="checkbox" v-model="task.canCreateOnTrigger" disabled />
                  </div>
                  <div class="col">
                    <input type="checkbox" v-model="task.forOrphanedTask" disabled />
                  </div>
                  <div class="col">
                    <input type="text" style="border: none" v-model="task.triggerSuccessMessage" disabled />
                  </div>
                  <div class="col">
                    {{
                      task.allowedTransitions &&
                      task.allowedTransitions.join(", ")
                    }}
                  </div>
                  <div class="col">
                    {{ task.allowedMergeTo && task.allowedMergeTo.join(", ") }}
                  </div>
                  <div class="col col-2">
                    {{ task.triggers && task.triggers.join(", ") }}
                  </div>
                  <div class="col col-1">
                    <span class="add-Btn" @click="editTaskType(index, task)" title="Edit" style="padding-right: 10px">
                      <img src="../assets/images/edit.svg" width="16" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedTask != null" class="pageDataWrapper pageActualDataWrapper col-2">
          <div class="contentHeader row m-0 align-items-center">
            <div class="col">Limit</div>
            <div class="col flex-3">Value (in mins)</div>
          </div>

          <div v-if="selectedTask != null" class="contentDataWrap">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col flex-2">Can Start</div>
                <div class="col">
                  <input type="number" v-model="selectedTask.limits.canStart" />
                </div>
              </div>

              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col flex-2">Overdue</div>
                <div class="col">
                  <input type="number" v-model="selectedTask.limits.overdue" />
                </div>
              </div>

              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col flex-2">Ready</div>
                <div class="col">
                  <input type="number" v-model="selectedTask.limits.ready" />
                </div>
              </div>

              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col flex-2">Voided</div>
                <div class="col">
                  <input type="number" v-model="selectedTask.limits.voided" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <table v-if="selectedTask != null" class="table ml-5 table-hover" style="width:300px">
                        <thead>
                            <tr>
                                <th>Limit</th>
                                <th>value (in min)</th>
                            </tr>
                        </thead>
                        <tbody v-if="selectedTask != null">
                            <tr>
                                <th>canStart</th>
                                <td><input type="number" v-model="selectedTask.limits.canStart">
                                </td>
                            </tr>
                            <tr>
                                <th>overdue</th>
                                <td><input type="number" v-model="selectedTask.limits.overdue"></td>
                            </tr>
                            <tr>
                                <th>Ready</th>
                                <td><input type="number" v-model="selectedTask.limits.ready"></td>
                            </tr>
                            <tr>
                                <th>Voided</th>
                                <td><input type="number" v-model="selectedTask.limits.voided"></td>
                            </tr>
                        </tbody>
                    </table> -->
      </div>
      <h3>Task Status - [{{ tenantOpt }}]</h3>
      <h6 style="padding-top: 5px; padding-left: 20px">Any of the Task Statuses updates will take effect in PROD after 15-60 mins or if the Cache is cleared for the tenant.</h6>
      <div class="pageDataWrapper pageActualDataWrapper">
        <div class="contentHeader row m-0 align-items-center">
          <div class="col">Statuses</div>
          <div class="col flex-3">Display Name</div>
          <div class="col flex-2">Category</div>
          <div class="col">Can Transition Manually</div>
          <div class="col">Can Start Session</div>
          <div class="col">Defer Cancellation</div>
          <div class="col">Can Transition To</div>
          <div class="col">Can Transition From</div>
          <div class="col">Actions</div>

          <!-- <div class="col-2"><img src="../assets/images/reportsIcon.svg" width="16">&nbsp;&nbsp;Reports</div> -->
        </div>

        <div class="contentDataWrapBottom">
          <div v-for="task in taskStatus" v-bind:key="task._id">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col">{{ task._id }}</div>

                <div class="col flex-3">
                  {{ task.displayName }}
                </div>
                <div class="col flex-2">
                  {{ task.category }}
                </div>
                <div class="dropdown dropdownAction col row m-0 align-items-center">
                  <input type="checkbox" v-model="task.canTransitionManually" disabled/>
                  
                </div>
                <div class="dropdown dropdownAction col row m-0 align-items-center">
                  <input type="checkbox" v-model="task.canStartSession" disabled/>
                </div>
                <div class="dropdown dropdownAction col row m-0 align-items-center">
                  <input type="checkbox"  v-model="task.deferCancellation" disabled/>
                 
                </div>
                <!-- if the canTransitionTo is single string value condition checking   -->
                <!-- <div class="col"
                  v-if="task.canTransitionTo && typeof (task.canTransitionTo) !== 'string' && task.canTransitionTo.length > 1">
                  <span v-for="(status, index) in  task.canTransitionTo " v-bind:key="index">{{
                    status.trim()
                  }}<span v-if="index < (task.canTransitionTo.length - 1)">, </span></span>
                </div> -->
                <div class="col" v-if="task.canTransitionTo &&
                    typeof task.canTransitionTo !== 'string' &&
                    task.canTransitionTo.length > 1
                    ">
                  <span v-for="(status, index) in task.canTransitionTo" v-bind:key="index">{{ status.trim()
                    }}<span v-if="index < task.canTransitionTo.length - 1">,
                    </span></span>
                  <b-button v-if="task.values" class="actionBtn clientShowBtn canTo"
                            @click="showTaskValuesModal(task.values)">{{ "Reason for Transition" }}
                  </b-button>
                </div>
                <div class="col" v-else-if="task.canTransitionTo &&
                  typeof task.canTransitionTo[0] === 'string' && task.canTransitionTo.length===1
                  ">
                  <span>{{ task.canTransitionTo[0].trim() }}</span>
                  <b-button v-if="task.values" class="actionBtn clientShowBtn canTo"
                            @click="showTaskValuesModal(task.values)">{{ "Reason for Transition" }}
                  </b-button>
                </div>
                <div class="col" v-else-if="task.canTransitionTo &&
                  typeof task.canTransitionTo === 'string' 
                  ">
                  <span>{{ task.canTransitionTo }}</span>
                  <b-button v-if="task.values" class="actionBtn clientShowBtn canTo"
                            @click="showTaskValuesModal(task.values)">{{ "Reason for Transition" }}
                  </b-button>
                </div>
                <div class="col" v-else>--</div>
                <!-- if the canTransitionFrom is single string value condition checking   -->
                <div class="col" v-if="task.canTransitionFrom &&
                  typeof task.canTransitionFrom !== 'string' &&
                  task.canTransitionFrom.length > 1
                  ">
                  <span v-for="(status, index) in task.canTransitionFrom" v-bind:key="index">{{ status.trim()
                    }}<span v-if="index < task.canTransitionFrom.length - 1">,
                    </span></span>
                </div>
                <div class="col" v-else-if="task.canTransitionFrom &&
                  typeof task.canTransitionFrom[0] === 'string' && task.canTransitionFrom.length===1
                  ">
                  <span>{{ task.canTransitionFrom[0].trim() }}</span>
                </div>
                <div class="col" v-else-if="task.canTransitionFrom &&
                  typeof task.canTransitionFrom === 'string'">
                  <span>{{ task.canTransitionFrom }}</span>
                </div>
                <div class="col" v-else>--</div>
                <div class="col" v-if="task">
                  <span class="add-Btn" @click="editStatus(index, task)" title="Edit" style="padding-right: 10px">
                    <img src="../assets/images/edit.svg" width="16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="taskValuesModal" hide-backdrop id="taskModal" centered title="Task Values" ok-title="Ok"
             @ok="taskValuesModal = false" @cancel="taskValuesModal = false">
      <div>
        <span v-for="(status, index) in deferredValues" v-bind:key="index">{{ status.trim()
          }}<span v-if="index < deferredValues.length - 1">, </span>
        </span>
      </div>
    </b-modal>

    <!-- addModal form for the add task type form building start  -->
    <b-modal id="addModal" hide-backdrop centered title="Add Task Type" title-class="test" ok-title="Save"
             @ok="addTaskType" :ok-disabled="disable_submit" @hidden="clearModal" @cancel="clearModal">
      <b-form ref="form">
        <!-- task name control -->
        <b-form-group label="Name *" label-for="name" invalid-feedback="Please enter a Name.">
          <b-form-input id="Name" v-model="addTaskObj.name" @input="validateTextInput(addTaskObj.name, 'name')"
                        @blur="validateTextInput(addTaskObj.name, 'name')" placeholder="Name"
                        :class="!validations.name ? 'in-valid' : 'valid'"></b-form-input>
        </b-form-group>
        <!-- Overdue control -->
        <b-form-group invalid-feedback="Please enter a overdue in number.">
          <label for="overdue">Overdue *
            <span class="sub-text">(in seconds like 900)</span></label>
          <b-form-input id="overdue" v-model="addTaskObj.overdue" placeholder="Overdue in seconds"
                        @input="validateNumericInput(addTaskObj.overdue, 'overdue')"
                        @blur="validateNumericInput(addTaskObj.overdue, 'overdue')" type="text"
                        :class="!validations.overdue ? 'in-valid' : 'valid'"></b-form-input>
        </b-form-group>
        <!-- Ready control -->
        <b-form-group invalid-feedback="Please enter a ready number.">
          <label for="ready">Ready * <span class="sub-text">(in seconds like -600)</span></label>
          <b-form-input type="text" @input="validateNumericInput(addTaskObj.ready, 'ready')"
                        @blur="validateNumericInput(addTaskObj.ready, 'ready')" id="ready" v-model="addTaskObj.ready"
                        placeholder="Ready in seconds" :class="!validations.ready ? 'in-valid' : 'valid'"></b-form-input>
        </b-form-group>
        <!-- Can Start control-->
        <b-form-group invalid-feedback="Please enter a can start in  number.">
          <label for="can-start">Can Start *<span class="sub-text">(in seconds like -900)</span></label>
          <b-form-input type="text" id="can-start" @input="validateNumericInput(addTaskObj.can_start, 'can_start')"
                        @blur="validateNumericInput(addTaskObj.can_start, 'can_start')" v-model="addTaskObj.can_start"
                        placeholder="Can Start in seconds" :class="!validations.can_start ? 'in-valid' : 'valid'"></b-form-input>
        </b-form-group>
        <!-- Voided control-->
        <b-form-group invalid-feedback="Please enter a voided in number.">
          <label for="voided">Voided *<span class="sub-text">(in seconds like 28800)</span></label>
          <b-form-input type="text" @input="validateNumericInput(addTaskObj.voided, 'voided')"
                        @blur="validateNumericInput(addTaskObj.voided, 'voided')" id="voided" v-model="addTaskObj.voided"
                        placeholder="Voided in seconds" :class="!validations.voided ? 'in-valid' : 'valid'"></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox id="suppressKnock" v-model.bool="addTaskObj.suppressKnock" name="suppressKnock"
                           unchecked-value=false value=true inline>
            Suppress Knock (for Night Rounding)
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <!-- Recurraning check control -->
          <b-form-checkbox id="checkbox-recurring" v-model.bool="addTaskObj.is_recurring" name="recurring"
                           unchecked-value="false" value="true" inline>
            Recurring
          </b-form-checkbox>
          <!-- Is Manua check control -->
          <b-form-checkbox id="checkbox-is-manual" v-model.bool="addTaskObj.is_manual" name="is_manual"
                           unchecked-value="false" value="true" inline>
            Is Manual
          </b-form-checkbox>
          <!-- Unique Per Visit check control -->
          <b-form-checkbox id="checkbox-unique-per-visit" v-model.bool="addTaskObj.unique_per_visit"
                           name="unique_per_visit" value="true" unchecked-value="false" inline>
            Unique Per Visit
          </b-form-checkbox>
          <!-- Prevent Auto Transition check control  -->
          <b-form-checkbox id="checkbox-prevent-auto-transition" v-model.bool="addTaskObj.prevent_auto_transition"
                           name="prevent_auto_transition" value="true" unchecked-value="false" inline>
            Prevent Auto Transition
          </b-form-checkbox>
          <!-- Hide In Drop In check control  -->
          <b-form-checkbox id="checkbox-hide-in-drop-in" v-model.bool="addTaskObj.hide_in_drop_in" name="hide_in_drop_in"
                           unchecked-value="false" value="true" inline>
            Hide In Drop In
          </b-form-checkbox>
        </b-form-group>
      </b-form>
    </b-modal>
    <!--addModal form add task type Ends here -->

    <!-- Edit model constrection starts from here  -->
    <b-modal id="editModal" hide-backdrop centered v-bind:title="'Edit Task Type - [' + tenantOpt + ']'" title-class="test" ok-title="Update"
             @ok="updateEditTaskType" @hidden="clearEditModal" @cancel="clearEditModal" no-close-on-esc no-close-on-backdrop>
      <div class="edit-form-container">
        <!-- {{ selectedTask }} -->
        <b-form ref="form">
          <!-- task name control -->
          <b-form-group label="Name" label-for="name" invalid-feedback="Please enter a Name.">
            <!-- name -->
            <b-form-input id="Name" v-model="selectTaskForEdit.name"
                          @input="validateTextInput(selectTaskForEdit.name, 'name')"
                          @blur="validateTextInput(selectTaskForEdit.name, 'name')" placeholder="Name"
                          :disabled="taskTypeEditEnable"></b-form-input>
            <!-- :class="!validations.name ? 'in-valid' : 'valid'" -->
          </b-form-group>
          <!-- Is Active -->
          <b-form-group>
            <b-form-checkbox id="checkbox-isActive" v-model.bool="selectTaskForEdit.isActive" name="isActive"
                             unchecked-value=false value=true inline>
              Is Active
            </b-form-checkbox>
          </b-form-group>
          <!-- hideInDropin -->
          <b-form-group>
            <b-form-checkbox id="checkbox-hideInDropin" v-model.bool="selectTaskForEdit.hideInDropin" name="hideInDropin"
                             unchecked-value=false value="true" inline>
              Task hidden for DropIn
            </b-form-checkbox>
          </b-form-group>

          <!-- Can Create on Trigger - CHECKBOX  canCreateOnTrigger-->
          <b-form-group>
            <b-form-checkbox id="checkbox-canCreateOnTrigger" v-model.bool="selectTaskForEdit.canCreateOnTrigger"
                             name="canCreateOnTrigger" unchecked-value=false value=true inline>
              Can Create on Trigger
            </b-form-checkbox>
          </b-form-group>
          <!-- For Orphaned Task - CHECKBOX -->
          <b-form-group>
            <b-form-checkbox id="checkbox-forOrphanedTask" v-model.bool="selectTaskForEdit.forOrphanedTask"
                             name="forOrphanedTask" unchecked-value=false value=true inline>
              For Orphaned Task
            </b-form-checkbox>
          </b-form-group>

          <!-- Is Manual - CHECKBOX -->
          <b-form-group>
            <b-form-checkbox id="checkbox-isManual" v-model.bool="selectTaskForEdit.isManual" name="isManual"
                             unchecked-value=false value=true inline>
              Is Manual
            </b-form-checkbox>
          </b-form-group>

          <!-- Is Unique Per Visit - CHECKBOX -->
          <b-form-group>
            <b-form-checkbox id="checkbox-isUniquePerVisit " v-model.bool="selectTaskForEdit.isUniquePerVisit"
                             name="isUniquePerVisit" unchecked-value=false value=true inline>
              Is Unique Per Visit
            </b-form-checkbox>
          </b-form-group>

          <!-- Prevent Auto Transition - CHECKBOX -->
          <b-form-group>
            <b-form-checkbox id="checkbox-preventAutoTransition" v-model.bool="selectTaskForEdit.preventAutoTransition"
                             name="preventAutoTransition" unchecked-value=false value=true inline>
              Prevent Auto Transition
            </b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="suppressKnock" v-model.bool="selectTaskForEdit.suppressKnock" name="suppressKnock"
                             unchecked-value=false value=true inline>
              Suppress Knock (for Night Rounding)
            </b-form-checkbox>
          </b-form-group>

          <!-- Allowed Transitions - MULTI-SELECT DROPDOWN to list all the Task Types other than the one being edited for. -->
          <b-form-group label="Allowed Transitions" label-for="allowedTransitions">
            <multiselect v-model="selectTaskForEdit.allowedTransitions" :options="arrayofTaskTypesForEdit"
                         :searchable="false" :close-on-select="false" :multiple="true" :clear-on-select="false"
                         :preserve-search="true" placeholder="Pick some" id="allowedTransitions" :preselect-first="false" :class="selectTaskForEdit.allowedTransitions === null ||
                selectTaskForEdit.allowedTransitions === ''
                ? 'in-valid'
                : 'valid'
                ">
            </multiselect>
          </b-form-group>
          <!-- Allowed Merge To - MULTI-SELECT DROPDOWN to list all the Task Types other than the one being edited for. -->
          <b-form-group label="Allowed Merge To" label-for="allowedMergeTo">
            <multiselect v-model="selectTaskForEdit.allowedMergeTo" :options="arrayofTaskTypesForEdit" :searchable="false"
                         :close-on-select="false" :multiple="true" :clear-on-select="false" :preserve-search="true"
                         placeholder="Pick some" id="allowedMergeTo" :preselect-first="false" :class="selectTaskForEdit.allowedMergeTo === null ||
                selectTaskForEdit.allowedMergeTo === ''
                ? 'in-valid'
                : 'valid'
                ">
            </multiselect>
          </b-form-group>
          <!-- Trigger - MULTI SELECT DROPDOWN with below list of Triggers -->
          <div class="d-flex"> 
          <b-form-group label="Trigger" label-for="triggers" style="width: 95%;">
            <multiselect v-model="selectTaskForEdit.triggers" :options="triggersArray" :searchable="false"
                         :close-on-select="false" :multiple="true" :clear-on-select="false" :preserve-search="true"
                         placeholder="Pick some" id="triggers" :preselect-first="false" :class="selectTaskForEdit.triggers === null ||
                selectTaskForEdit.triggers === ''
                ? 'in-valid'
                : 'valid'
                ">
            </multiselect>
          </b-form-group>
            <span class="add-Btn mt-3" @click="handleTextEditor" >
              <font-awesome-icon class="icon-container" icon="plus-circle"  />
            </span>
        </div>

          <!-- Trigger Success Message (triggerSuccessMessage) - Free Text Box -->

          <b-form-group label="Trigger Success Message" label-for="triggerSuccessMessage"
                        invalid-feedback="Please enter a message.">
            <b-form-textarea id="triggerSuccessMessage" v-model="selectTaskForEdit.triggerSuccessMessage" rows="3"
                             placeholder="Enter your message here"></b-form-textarea>
          </b-form-group>

          <!-- Trigger Failed Message (triggerFailedMessage) - Free Text Box -->
          <b-form-group label="Trigger Failed Message" label-for="triggerFailedMessage"
                        invalid-feedback="Please enter a message.">
            <b-form-textarea id="triggerFailedMessage" v-model="selectTaskForEdit.triggerFailedMessage" rows="3"
                             placeholder="Enter your message here"></b-form-textarea>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

    <b-modal id="addTextModal" title="Add Option For Triggers" no-close-on-esc no-close-on-backdrop dialog-class="addTextModalContainer"
     @ok="addOptionConfirm" @hidden="cancelEditAction" @cancel="cancelEditAction"  :ok-disabled="additionalOption==''" ok-title="Add">
    <input type="text" v-model="additionalOption" placeholder="Enter Option value" @input="validateInput">
    <p class="invalidTextMessage" v-if="inputTextError"> Enter some menaingful text</p>
    </b-modal>
      

    <!-- Edit model constrection starts from here  -->

    <!-- addStatusModal form for the add / Update status form building start  -->
    <b-modal id="addStatusModal" hide-backdrop centered :title="okStatusTitle" title-class="test"
             :ok-title="okStatusTitleBtn" @ok="handleOkClick()" :ok-disabled="disable_status_submit" @hidden="clearStatusModal"
             @cancel="clearStatusModal">
      <b-form ref="form">
        <b-form-group label="Task Status" label-for="status">
          <b-form-input id="status" v-model="addStatusObj._id" @blur="isStatusOkConditionSatisfied"
                        @input="validateTaskStatusField(addStatusObj._id, '_id')" placeholder="Enter Status" :class="addStatusObj._id === null || addStatusObj._id === ''
              ? 'in-valid'
              : 'valid'
              " :disabled="isTaskStatusEditEnable"></b-form-input>
          <p v-if="statusValidationText !== ''" style="color: red; font-size: 12px">
            {{ statusValidationText }}
          </p>
        </b-form-group>
        <!-- displayName -->
        <b-form-group label="Enter Display Name" label-for="displayName">
          <b-form-input id="displayName" v-model="addStatusObj.displayName" @blur="isStatusOkConditionSatisfied"
                        placeholder="Display Name" :class="addStatusObj.displayName === null ||
              addStatusObj.displayName === ''
              ? 'in-valid'
              : 'valid'
              "></b-form-input>
        </b-form-group>
        <!-- Category -->
        <b-form-group label="Select Category" label-for="category">
          <multiselect v-model="addStatusObj.category" :options="statusCategories" :searchable="false"
                       :close-on-select="false" :multiple="false" :clear-on-select="false" :preserve-search="true"
                       placeholder="Pick some" id="category" :preselect-first="true" @close="isStatusOkConditionSatisfied" :class="addStatusObj.category === null || addStatusObj.category === ''
              ? 'in-valid'
              : 'valid'
              ">
          </multiselect>
        </b-form-group>
        <!-- canTransitionManually -->
        <b-form-group>
          <b-form-checkbox id="canTransitionManually" v-model="addStatusObj.canTransitionManually" name="canTransitionManually"
          @change="isStatusOkConditionSatisfied" unchecked-value="false" value="true" inline>
              Can Transition Manually ?
            </b-form-checkbox>
        </b-form-group>
        <!-- canStartSession -->
        <b-form-group>
          <b-form-checkbox id="canStartSession" v-model="addStatusObj.canStartSession" name="canStartSession"
          @change="isStatusOkConditionSatisfied" unchecked-value=false value=true inline>
          Can Start Session ?
            </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox id="deferCancellation" v-model="addStatusObj.deferCancellation" name="deferCancellation"
          @change="isStatusOkConditionSatisfied" unchecked-value=false value=true inline>
          Defer Cancellation ?
            </b-form-checkbox>
        </b-form-group>
        <!-- future reference -->
        <!-- skipConfirmation  -->
        <!-- <b-form-group>
          <label class="checkbox-container">
            Skip Confirmation ?
            <input type="checkbox" :value="addStatusObj.skipConfirmation" id="skipConfirmation"
              v-model="addStatusObj.skipConfirmation" @change="isStatusOkConditionSatisfied" />
            <span class="checkmark"></span>
          </label>
        </b-form-group> -->
        <!-- canTransitionTo -->
        <b-form-group label="Can Transition To" label-for="canTransitionTo">
          <multiselect v-model="addStatusObj.canTransitionTo" :options="statusArrayDropDownObj" :searchable="false"
                       :close-on-select="false" :multiple="true" :clear-on-select="false" :preserve-search="true"
                       placeholder="Pick some" id="canTransitionTo" @close="isStatusOkConditionSatisfied" 
                       :class="addStatusObj.canTransitionTo === null ||
              addStatusObj.canTransitionTo.legth === 0
              ? 'in-valid'
              : 'valid'
              ">
          </multiselect>
        </b-form-group>

        <!-- canTransitionFrom -->
        <b-form-group label="Can Transition From" label-for="canTransitionFrom">
          <multiselect v-model="addStatusObj.canTransitionFrom" :options="statusArrayDropDownObj" :searchable="false"
                       :close-on-select="false" :multiple="true" :clear-on-select="false" :preserve-search="true"
                       placeholder="Pick some" id="canTransitionFrom"  @close="isStatusOkConditionSatisfied"
                       :class="addStatusObj.canTransitionFrom === null ||
              addStatusObj.canTransitionFrom.legth === 0
              ? 'in-valid'
              : 'valid'
              ">
          </multiselect>
        </b-form-group>
      </b-form>
    </b-modal>
    <!--addStatusModal form add status Ends here -->
  </section>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.min.js">
</script>
<script src="https://cdn.jsdelivr.net/npm/v-mask/dist/v-mask.min.js"></script>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Multiselect from "vue-multiselect";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import cloneDeep from 'lodash/cloneDeep';


Vue.use(VueToast);
Vue.component("multiselect", Multiselect);
export default {
  components: {
    ModelSelect,
    Multiselect
  },
  data() {
    return {
      tenants: [{ text: "-SELECT-", value: "" }],
      taskTyp: [],
      tenantsList: [],
      deferredValues: [],
      okTaskTitle: "Add Task Type",
      taskStatus: "",
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      selectedTask: null,
      perVisit: "",
      manual: "",
      transition: "",
      isChecked: "",
      clickValue: [],
      isActive: "",
      toggleValues: false,
      taskTriggerOrder: "",
      isUniquePerVisit: "",
      canCreateOnTrigger: "",
      forOrphanedTask: "",
      allowedTransitions: "",
      allowedMergeTo: "",
      triggerSuccessMessage: "",
      task: [],
      taskValuesModal: false,
      modalValues: [],
      voided: "",
      overdue: "",
      canStart: "",
      ready: "",
      selectedRow: null,
      tenantOpt: "",
      // adding these objects to avoid the undefined values supplied when no checkbox was touched during the add Task type action form
      defaultAddTaskObj: {
        is_recurring: "false",
        is_manual: "false",
        unique_per_visit: "false",
        prevent_auto_transition: "false",
        hide_in_drop_in: "false"
      },
      addTaskObj: {
        is_recurring: "false",
        is_manual: "false",
        unique_per_visit: "false",
        prevent_auto_transition: "false",
        hide_in_drop_in: "false"
      },
      disable_submit: true,
      disable_status_submit: true,
      is_retry: false,
      //validating fields
      validations: {
        name: true,
        overdue: true,
        ready: true,
        can_start: true,
        voided: true
      },
      //add task status model related variables
      statusArrayObj: [],
      statusArrayDropDownObj: [],
      statusCategories: [],
      addStatusObj: {
        _id: "",
        displayName: "",
        category: "",
        canTransitionManually: false,
        canStartSession: false,
        canTransitionTo: [],
        canTransitionFrom: []
      },
      defaultAddStatusObj: {
        _id: "",
        displayName: "",
        category: "",
        canTransitionManually: false,
        canStartSession: false,
        canTransitionTo: [],
        canTransitionFrom: []
      },
      editStatusOBJ: {},
      statusValidationText: "",
      isTaskStatusEditEnable: false,
      okStatusTitle: "Add Status",
      okStatusTitleBtn: "Save",
      taskTypeEditEnable: false,
      selectTaskForEdit: {},
      arrayofTaskTypesForEdit: [],
      triggersArray: [
        "KEYEVENT_ACTION_DOWN_F12",

        "KEYEVENT_ACTION_DOWN_F9",

        "KEYEVENT_ACTION_DOWN_F10",

        "KEYEVENT_ACTION_DOWN_F11",

        "ACTIVITIES_PATIENT_DISCHARGE_PREP",

        "IDA_PATIENT_ROOMED",

        "ACTIVITIES_PATIENT_ADMITTED",

        "ACTIVITIES_PATIENT_TRANSFERRED",

        "ACTIVITIES_PATIENT_UPDATED",

        "Admitted",

        "FUTURE_ROUNDING_TASK"
      ],
      additionalOption:"",
      inputTextError:false
    };
  },

  mounted() {
    this.fetchTenants();
    $("input").attr("autocomplete", "off");
  },
  methods: {
    isBoolean(value){
      return value === 'true' ? true : value === 'false' ? false : Boolean(value);
    },
    cancelEditAction(){
      this.$bvModal.hide('addTextModal')
      this.additionalOption=''
    },
    addOptionConfirm(){
      this.triggersArray.push(this.additionalOption)
    },
    validateInput(){
      if(this.additionalOption==''){
        this.inputTextError=true
      }
      else{
        this.inputTextError=false
      }
    },
    handleTextEditor(){
      this.$bvModal.show('addTextModal')
    },
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace("-", "")
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text || e.value })
        );
        console.log("fetchTenants", this.tenantsList);
      } catch (error) {
        console.error(error);
      }
    },
    showTaskValuesModal(values) {
      this.modalValues = values;
      this.taskValuesModal = true;
    },
    async fetchStatusValues() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var deferredValuesRequest = new Request(
        config.CAREAI_VIRTUAL +
        `/tenants/${this.tenantOpt}/dictionary/VIRTUAL_NURSING_REASON_DEFERRED`,
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      try {
        var defferedValues = await fetch(deferredValuesRequest);
        if (defferedValues.status == 503) {
          return this.fetchStatusValues();
        }
        var response = await defferedValues.json();
        this.deferredValues = response.VIRTUAL_NURSING_REASON_DEFERRED.values;
      } catch (error) {
        console.error(error);
      }
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id;
      } else {
        return "";
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.tenantOpt = this.lastSelectedTenant;
      this.taskType();
      this.fetchStatusValues();
    },
    getDropdownValues(tenant) {
      console.log("getDropdownValues", tenant);
      return this.tenantsList.filter(
        (e) => e.id === tenant || e.name === tenant
      );
    },
    async taskType() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.CAREAI_VIRTUAL +
        `/tenants/${this.tenantOpt}/taskTypes?isActive="false"`;
      var tenant_task_type = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantTask = await fetch(tenant_task_type);
        if (tenantTask.status == 503) {
          return this.taskType();
        }
        var response = await tenantTask.json();
        this.taskTyp = response.taskTypes.map((type) => ({
          ...type,
          limits: {
            ...type.limits,
            canStart: type.limits.canStart / (1000 * 60),
            overdue: type.limits.overdue / (1000 * 60),
            ready: type.limits.ready / (1000 * 60),
            voided: type.limits.voided / (1000 * 60)
          }
        }));
      } catch (error) {
        console.error(error);
      }
      var url =
        config.OPERATIONS_SERVICE + `/tenants/${this.tenantOpt}/task-statuses`;
      var tenant_task_status = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantstatus = await fetch(tenant_task_status);
        if (tenantstatus.status == 503) {
          return this.taskType();
        }
        var response = await tenantstatus.json();
        this.taskStatus = response;
        this.prepareStatusAndCategories(this.taskStatus);
        this.taskStatus.forEach((e) => {
          if (e._id === "DEFERRED") {
            e.values = this.deferredValues;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    prepareStatusAndCategories(arrayOfObjects) {
      this.statusArrayObj = arrayOfObjects.reduce((result, obj) => {
        if (!result.includes(obj._id)) {
          result.push(obj._id);
        }
        return result;
      }, []);
      this.statusCategories = arrayOfObjects.reduce((result, obj) => {
        result.push(obj.category);
        return result;
      }, []);
      this.statusCategories = [...new Set(this.statusCategories)];
      this.statusArrayDropDownObj = this.statusArrayObj.filter(
        (x) => x !== "IN_PROGRESS"
      );
      // this.statusArrayDropDownObj.push('ALL');
      this.statusCategories.sort();
      this.statusArrayDropDownObj.sort();
    },

    async updateTask() {
      const selectTaskForUpdate = JSON.parse(JSON.stringify(this.selectedTask));
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.tenantOpt}/taskTypes/${selectTaskForUpdate._id}`;
      const updateObject = {
        isActive: selectTaskForUpdate.isActive,
        taskTriggerOrder: selectTaskForUpdate.taskTriggerOrder,
        isUniquePerVisit: selectTaskForUpdate.isUniquePerVisit,
        canCreateOnTrigger: selectTaskForUpdate.canCreateOnTrigger,
        forOrphanedTask: selectTaskForUpdate.forOrphanedTask,
        triggerSuccessMessage: selectTaskForUpdate.triggerSuccessMessage,
        allowedTransitions: selectTaskForUpdate.allowedTransitions,
        allowedMergeTo: selectTaskForUpdate.allowedMergeTo,
        hideInDropin: selectTaskForUpdate.hideInDropin,
        limits: {
          voided:
            selectTaskForUpdate.limits.voided &&
            parseInt(selectTaskForUpdate.limits.voided) * 60 * 1000,
          canStart:
            selectTaskForUpdate.limits.canStart &&
            parseInt(selectTaskForUpdate.limits.canStart) * 60 * 1000,
          ready:
            selectTaskForUpdate.limits.ready &&
            parseInt(selectTaskForUpdate.limits.ready) * 60 * 1000,
          overdue:
            selectTaskForUpdate.limits.overdue &&
            parseInt(selectTaskForUpdate.limits.overdue) * 60 * 1000
        }
      };
      var update_task = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify(updateObject),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var updatetask = await fetch(update_task);
        if (update_task.status == 503) {
          return this.updateTask();
        }
        var response = await updatetask.json();
        this.update_Task = response;
        if (updatetask.status != 200) {
          this.commandError = "Failed to update task type";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message:
              "Successfully updated task type. Please request for the Cache to be cleared after the update.",
            type: "success"
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    onTaskTypeRowClicked($event, taskType) {
      this.selectedTask = taskType;
    },
    toggleSelectedRow(index) {
      if (this.selectedRow === index) {
        this.selectedRow = null;
      } else {
        this.selectedRow = index;
      }
    },

    async showTaskType() {
      this.$bvModal.show("addModal");
    },

    async showStatusModel() {
      this.$bvModal.show("addStatusModal");
      this.okStatusTitle = "Add Status";
      this.okStatusTitleBtn="Save"

    },
    // clering the value to it's previous state (ACID)
    async clearStatusModal() {
      this.addStatusObj = this.defaultAddStatusObj;
      this.$bvModal.hide("addStatusModal");
      this.isTaskStatusEditEnable=false
    },

    // clering the value to it's previous state (ACID)
    async clearModal() {
      this.addTaskObj = this.defaultAddTaskObj;
      this.$bvModal.hide("addModal");
    },

    async clearEditModal() {
      this.taskTypeEditEnable = false;
      this.selectTaskForEdit = {}; 
      // need to update the object with selected values
      this.$bvModal.hide("editModal");
    },

    //AddTaskType call Handelr method to process the data and hit the insert API
    async addTaskType() {
      //processing the model data as per our requirement
      if (!this.is_retry) {
        Object.keys(this.addTaskObj).map((key) => {
          //converting to numbersin seconds to milli seconds
          if (["overdue", "ready", "can_start", "voided"].indexOf(key) != -1) {
            this.addTaskObj[key] = this.addTaskObj[key] * 1000;
          }
          //converting to boolean values
          if (
            [
              "is_recurring",
              "is_manual",
              "unique_per_visit",
              "prevent_auto_transition",
              "hide_in_drop_in"
            ].indexOf(key) != -1
          ) {
            this.addTaskObj[key] =
              this.addTaskObj[key] === "true" ? true : false;
          }
        });
      }
      this.addTaskObj.suppressKnock=this.isBoolean(this.addTaskObj.suppressKnock);
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      //for local checking
      var url =
        config.OPERATIONS_SERVICE + `/tenants/${this.tenantOpt}/taskTypes`;
      //preparingh the API request headers
      var add_task_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.addTaskObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        //creating the response object for checking and evaluating the API call status messages
        var addTaskResponse = await fetch(add_task_request);
        if (addTaskResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (addTaskResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (addTaskResponse.status == 503) {
          this.is_retry = true;
          return this.addTaskType();
        }
        if (addTaskResponse.status != 200) {
          this.commandError = "Failed to add task type";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully added new task type",
            type: "success"
          });
          //clearing the model object on every successfull insertion
          this.addTaskObj = this.defaultAddTaskObj;
          this.is_retry = false;
          this.clearModal();
          this.taskType();
        }
      } catch (tex) {
        //error handler and toaster
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    validateNumericInput(modelValue, key) {
      let regExp = /^-?\d*\.?\d+$/;
      if (!regExp.test(modelValue)) {
        this.validations[key] = false;
        this.isOkConditionSatisfied();
      } else {
        this.validations[key] = true;
        this.isOkConditionSatisfied();
      }
    },
    validateTextInput(modelValue, key) {
      if (modelValue) {
        if (modelValue.trim() === "") {
          this.validations[key] = false;
          this.isOkConditionSatisfied();
        } else {
          this.validations[key] = true;
          this.isOkConditionSatisfied();
        }
      } else {
        this.validations.name = false;
        this.isOkConditionSatisfied();
      }
    },
    //checking and enable and disable the ok button
    isOkConditionSatisfied() {
      if (
        this.validations.name &&
        this.validations.overdue &&
        this.validations.ready &&
        this.validations.can_start &&
        this.validations.voided
      ) {
        this.disable_submit = false;
      } else {
        this.disable_submit = true;
      }
    },
    isStatusOkConditionSatisfied() {
      //checking and updating the "IN_Progress" in dropdown
      if (this.addStatusObj.canTransitionManually === true) {
        this.statusArrayDropDownObj = this.statusArrayObj;
        this.statusArrayDropDownObj.sort();
      } else if (this.addStatusObj.canTransitionManually === false) {
        this.statusArrayDropDownObj = this.statusArrayObj.filter(
          (x) => x !== "IN_PROGRESS");
        this.statusArrayDropDownObj.sort();
        //need to update the previously selected In Progress status changes
        //force updating the selection if inprogress
        this.addStatusObj.canTransitionTo = this.addStatusObj.canTransitionTo.filter(
          (x) => x !== "IN_PROGRESS");
        this.addStatusObj.canTransitionFrom = this.addStatusObj.canTransitionFrom.filter(
          (x) => x !== "IN_PROGRESS");
      }

      if (
        this.addStatusObj._id &&
        this.addStatusObj.displayName &&
        this.addStatusObj.category &&
        this.addStatusObj.canTransitionTo &&
        this.addStatusObj.canTransitionFrom
      ) {
        this.disable_status_submit = false;
      } else {
        this.disable_status_submit = true;
      }
    },
    validateTaskStatusField(value, field) {
      if (field === "_id") {
        value = value.toUpperCase();
        this.addStatusObj._id = this.addStatusObj._id.toUpperCase().trim();
        if (this.statusArrayObj.indexOf(value) !== -1) {
          this.disable_status_submit = true;
          this.statusValidationText = `${value} is present in the existing statues, Please try different value.`;
        } else {
          this.statusValidationText = "";
        }
      }
    },
    async addStatus() {
      //processing the model data as per our requirement
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      //for local checking
      var url =
        config.OPERATIONS_SERVICE + `/tenants/${this.tenantOpt}/task-statuses`;
      //preparingh the API request headers
      this.addStatusObj["tenant"] = this.tenantOpt;
      this.addStatusObj["_id"]=this.addStatusObj["_id"].replace(/ /g, '_');
      var add_status_request = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.addStatusObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        //creating the response object for checking and evaluating the API call status messages
        var addStatusResponse = await fetch(add_status_request);
        if (addStatusResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (addStatusResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (addStatusResponse.status == 503) {
          return this.addStatus();
        }
        if (addStatusResponse.status != 200) {
          this.commandError = "Failed to add status type";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message: "Successfully added new status",
            type: "success"
          });
          //clearing the model object on every successfull insertion
          this.addStatusObj = this.defaultAddStatusObj;
          this.clearStatusModal();
          this.taskType();
        }
      } catch (tex) {
        //error handler and toaster
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    editStatus(index, task) {
      this.addStatusObj = cloneDeep(task);
      this.addStatusObj["canTransitionFrom"] =
        this.addStatusObj["canTransitionFrom"] === "*"
          ? "ALL"
          : this.addStatusObj["canTransitionFrom"];
      this.addStatusObj["canTransitionTo"] =
        this.addStatusObj["canTransitionTo"] === "*"
          ? "ALL"
          : this.addStatusObj["canTransitionTo"];
      this.isTaskStatusEditEnable = true;
      this.okStatusTitle = `Update Status - [${this.tenantOpt}]`;
      this.okStatusTitleBtn = "Update";
      this.$bvModal.show("addStatusModal");
    },
    async updateTaskStatus() {
      //edit action
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.tenantOpt}/task-statuses/${this.addStatusObj._id}`;
      this.addStatusObj["tenant"] = this.tenantOpt;
      var update_task_status = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.addStatusObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var updateStatusResponse = await fetch(update_task_status);
        if (updateStatusResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (updateStatusResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (updateStatusResponse.status == 503) {
          return this.updateTaskStatus();
        }
        if (updateStatusResponse.status != 200) {
          this.commandError = "Failed to update task status";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message:
              "Task status updated successfully. Please clear the cache to show effect of the update.",
            type: "success"
          });
          //clearing the model object on every successfull insertion
          this.addStatusObj = this.defaultAddStatusObj;
          this.isTaskStatusEditEnable = false;
          this.okStatusTitle = "Add Status";
          this.okStatusTitleBtn = "Update";
          this.clearStatusModal();
          this.taskType();
        }
      } catch (tex) {
        this.commandError = "Failed to update task status due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    handleOkClick() {
      // Conditionally choose a function to call based on isTaskStatusEditEnable condition
      if (this.isTaskStatusEditEnable) {
        this.updateTaskStatus();
      } else {
        this.addStatus();
      }
    },
    editTaskType(index, task) {
      // preparing the tasks array for drop downs
      this.arrayofTaskTypesForEdit = this.taskTyp.reduce((result, obj) => {
        //condition to avoaid the same kind of the selection from the drop down selection
        if (obj._id !== task._id) {
          result.push(obj._id);
        }
        return result;
      }, []);
      this.arrayofTaskTypesForEdit = [...new Set(this.arrayofTaskTypesForEdit)];
      this.taskTypeEditEnable = true;
      this.selectTaskForEdit = JSON.parse(JSON.stringify(task));
      this.selectTaskForEdit.suppressKnock = this.selectTaskForEdit.limits.suppressKnock == 1000 ? true : false;
      this.$bvModal.show("editModal");
    },
    async updateEditTaskType() {
      console.log("updateEditTaskType", this.selectTaskForEdit);
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.tenantOpt}/taskTypes/${this.selectTaskForEdit._id}`;
      const updateObject = {
        name: this.selectTaskForEdit.name,
        isActive: this.isBoolean(this.selectTaskForEdit.isActive),
        isUniquePerVisit: this.isBoolean(this.selectTaskForEdit.isUniquePerVisit),
        canCreateOnTrigger: this.isBoolean(this.selectTaskForEdit.canCreateOnTrigger),
        forOrphanedTask: this.isBoolean(this.selectTaskForEdit.forOrphanedTask),
        allowedTransitions: this.selectTaskForEdit.allowedTransitions,
        allowedMergeTo: this.selectTaskForEdit.allowedMergeTo,
        hideInDropin: this.isBoolean(this.selectTaskForEdit.hideInDropin),
        suppressKnock: this.isBoolean(this.selectTaskForEdit.suppressKnock),
        limits: {
          voided: this.selectTaskForEdit.limits.voided && parseInt(this.selectTaskForEdit.limits.voided) * 60 * 1000,
          canStart: this.selectTaskForEdit.limits.canStart && parseInt(this.selectTaskForEdit.limits.canStart) * 60 * 1000,
          ready: this.selectTaskForEdit.limits.ready && parseInt(this.selectTaskForEdit.limits.ready) * 60 * 1000,
          overdue: this.selectTaskForEdit.limits.overdue && parseInt(this.selectTaskForEdit.limits.overdue) * 60 * 1000,
          suppressKnock: this.selectTaskForEdit.suppressKnock ? 1000 : this.selectTaskForEdit.limits.suppressKnock && parseInt(this.selectTaskForEdit.limits.suppressKnock)
        }
      };

      if (this.selectTaskForEdit.triggerFailedMessage) {
        updateObject["triggerFailedMessage"] =
          this.selectTaskForEdit.triggerFailedMessage;
      }
      if (this.selectTaskForEdit.triggerSuccessMessage) {
        updateObject["triggerSuccessMessage"] =
          this.selectTaskForEdit.triggerSuccessMessage;
      }
      if (this.selectTaskForEdit.taskTriggerOrder) {
        updateObject["taskTriggerOrder"] =
          this.selectTaskForEdit.taskTriggerOrder;
      }
      if (this.selectTaskForEdit.isManual) {
        updateObject["isManual"] =this.isBoolean(this.selectTaskForEdit.isManual);
      }
      if (this.selectTaskForEdit.triggers) {
        updateObject["triggers"] = this.selectTaskForEdit.triggers;
      }
      if (this.selectTaskForEdit.frequency) {
        updateObject["frequency"] = this.selectTaskForEdit.frequency;
      }
      //preventAutoTransition
      if (this.selectTaskForEdit.preventAutoTransition) {
        updateObject["preventAutoTransition"] =
        this.isBoolean(this.selectTaskForEdit.preventAutoTransition);
      }
      var update_task = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify(updateObject),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var updatetask = await fetch(update_task);
        if (update_task.status == 503) {
          return this.updateTask();
        }
        var response = await updatetask.json();
        this.update_Task = response;
        if (updatetask.status != 200) {
          this.commandError = "Failed to update task type";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.$bvModal.hide("editModal");

          this.commandError = "";
          Vue.$toast.open({ message: "Successfully updated task type. Please request for the Cache to be cleared after the update.", type: "success" });

          this.taskType();
          this.fetchStatusValues();
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
  url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
  url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}


::v-deep .ui.search.dropdown .text {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
}

.ui.selection.dropdown {
  border: none !important;

  i.dropdown.icon {
    display: none;
  }
}


*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
select.form-control:hover,
textarea.form-control:hover {
  box-shadow: none;
  background: #fff;
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  color: #6a6a6a;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 40px !important;
  margin-right: 40px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem > a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover > a,
.menuItem.active > a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics > span {
  position: relative;
  top: -1px;
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
}

.dashboardBlock {
  background: red;
  margin: 0 15px;
  padding: 30px;
  border-radius: 10px;
}

.dashboardIcon {
  float: left;
  margin-right: 20px;
}

.dashboardNumber {
  float: left;
  font-size: 45px;
  color: #fff;
  line-height: 1;
}

.dashboardNumber > span {
  font-size: 16px;
  display: block;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
    rgba(0, 192, 255, 1) 0%,
    rgba(0, 192, 255, 1) 35%,
    rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
    rgba(0, 255, 169, 1) 0%,
    rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
    rgba(31, 201, 253, 1) 0%,
    rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
    rgba(163, 44, 223, 1) 0%,
    rgba(138, 54, 220, 1) 33%,
    rgba(77, 79, 215, 1) 66%,
    rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
    rgba(0, 255, 255, 1) 0%,
    rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
    rgba(163, 44, 223, 1) 0%,
    rgba(138, 54, 220, 1) 33%,
    rgba(77, 79, 215, 1) 66%,
    rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
    rgba(254, 193, 148, 1) 0%,
    rgba(254, 168, 141, 1) 30%,
    rgba(254, 107, 125, 1) 50%,
    rgba(254, 8, 99, 1) 70%,
    rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 0 15px;
  background: #fff;
  width: 100%;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  margin: 0 15px 30px 15px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  max-width: calc((100vw / 7) - 35px);
  width: calc((100vw / 7) - 35px);
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 0 25px;
  font-size: 55px;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: center;
  padding: 10px 5px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
    display: inline-flex;
    padding: 0px 10px;
    font-size: 16px;
    min-width: 360px;
    max-width: 360px;
    border-radius: 5px;
    margin-left: 15px;
    align-items: center;
    text-overflow: ellipsis;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background: transparent !important;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #00b5da;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #f2fdff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
}

.yesBtn,
.noBtn {
  margin-right: 15px;
  border: 1px solid #dae1f2 !important;
  border-radius: 10px;
  padding: 5px 20px !important;
}

.noBtn {
  margin-left: 15px;
  margin-right: 0px;
}

.yesBtn:hover,
.noBtn:hover {
  background: #fff !important;
  color: #00b5da !important;
}

.modal-header {
  background: #50b9d4;
  color: #fff;
}

.modal-title {
  font-size: 14px !important;
}

.modal-body {
  color: #7b7b7b;
}

.modal-footer {
  background: #f2fdff;
  color: #1a80a8;
  justify-content: center;
}

.modal-footer .btn {
  padding: 5px 20px;
  border-radius: 6px;
  min-width: 100px;
  //border: 1px solid #50B9D4 !important;
}

.modal-footer .btn:hover {
  background: #fff;
  color: #50b9d4;
  cursor: pointer;
}

.modal-footer > :not(:last-child) {
  margin-right: 15px;
}

.modal-footer > :not(:first-child) {
  margin-left: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

// .filterText {
//   color: #fff;
//   opacity: 0.4;
//   padding-right: 5px;
// }

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
}

.filterDropDownData > a,
.actionDropDownData > a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData > a:hover,
.filterDropDownData > a.active,
.actionDropDownData > a:hover,
.actionDropDownData > a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.filterDropDownData > a::after,
.actionDropDownData > a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData > a:last-child::after,
.filterDropDownData > a.active::after,
.filterDropDownData > a:hover:after,
.actionDropDownData > a:last-child::after,
.actionDropDownData > a.active::after,
.actionDropDownData > a:hover:after {
  display: none;
}

.pageDataWrapper {
  padding: 20px;
}

.tableDataWrapper {
}

.contentHeader {
  background: #ebebeb;
  height: 52px;
  color: #484848;
  border-radius: 5px;
}

.contentHeader > div {
  border-left: 1px solid #f7f7f7; 
  display: inline-flex;
  align-items: center;
  font-size: 15px !important;
  text-align:center;
  line-height:normal;
}

.contentHeader > div:first-child {
  border-left: 0px solid;
}

.contentHeader td {
  padding: 0 15px;
}

.contentRow > td {
  border-bottom: 1px solid #daf9ff;
  align-items: center;
  padding: 0 15px;
  background: #fff !important;
  color: #6a6a6a;
  cursor: pointer;
}

.contentRow.error td {
  background: #f16161 !important;
  color: #fff;
}

.contentRow.active td {
  background-color: #f4fbfe !important;
}

.contentRow:hover td {
  background-color: #f4fbfe !important;
}

.contentRow.error:hover td {
  background-color: #f57676 !important;
}

.contentDataWrap {
  overflow: auto;
  overflow-y: auto;
  height: 30vh;
}

.contentDataWrapBottom {
  overflow: auto;
  overflow-y: auto;
  height: 23vh;
  font-size: 15px !important;
}

.contentDataWrapper {
  align-content: flex-start;
}

.contentRow {
  height: 50px;
}

.contentData {
  background: #fff;
  color: #6a6a6a;
  height: auto;
  margin-top: 10px !important;
  cursor: pointer;
  min-height: 48px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData > div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}

.contentData > div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
}

.deviceStatus {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  background: #66be6d;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  max-width: 200px;
  min-width: 200px;
}

.actionDropDown {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 140px;
  text-align: left;
}

.actionDropDown:after {
  right: 30px;
  position: absolute;
  top: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData > div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.deviceName > span {
  color: #1dd8f6;
  padding-right: 15px;
}

.deviceDataWrapper .contentData {
  height: 80px;
}

.deviceDataWrapper .contentData > div:last-child {
  display: inline-flex;
  overflow: unset;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 36px;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#3288D2;
}

.hasNotifications {
  max-width: 160px;
}

.selectArea {
  max-width: 130px;
}

.userContentWrapper .contentData > div:first-child,
.userContentWrapper .contentData > div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData > div span {
  color: #6a6a6a;
  padding-right: 5px;
}

.btn {
  background: #1dd8f6;

  color: #fff;
  // position:absolute;
  // top:250px;
  // left:500px;
  border-color: #1dd8f6;
  padding: 5px 10px;
  border: 0px;
  height:38px
}
.pageHeader .btn{
  background: #575757;
  font-size:15px
}
.pageHeader .btn:hover{
  background:#1dd8f6;
  color:#fff;
}
.userDetailContentHeader {
  background: #ebebeb;
  color: #484848;
  font-size: 15px;
  padding: 15px 0;
  border-radius: 5px;
}

.userDetailContentHeader > div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem.disabled,
.buttonItem[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

a.buttonItem.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border:1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 30px !important;
  max-height: calc(100vh - 300px);
  overflow: hidden;
  overflow-y: auto;
  min-height: 100px;
}

.userDemograpics {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #dceaea;
}

.h-100 {
  overflow-x: hidden;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 20px;
}

.userDetails .col:last-child {
  padding-left: 20px;
}

.addBtn {
  border: 1px solid #dceaea !important;
  border-radius: 5px;
  padding: 7px 15px !important;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
  cursor: pointer;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

.selectedItem > img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
  width: 67px;
  cursor: pointer;
}

@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .expand-transition {
    transition: all 0.5s ease;
  }

  .expand-enter,
  .expand-leave {
    height: 0;
    opacity: 0;
  }

  .category {
    height: 100px;
    width: 250px;
    padding: 10px;
  }

  .dashboardIcon > img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 36px;
  }

  .dashboardNumber > span {
    font-size: 12px;
    display: block;
  }

  .facilityInfo .dashboardNumber {
    padding: 0 13px;
    font-size: 36px;
  }

  .facilityName {
    font-size: 14px;
  }

  .infoWrapper {
    padding: 10px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .actionDropDown {
    width: 125px;
  }

  .userContentWrapper .contentData > div:nth-child(2) .text-right {
    text-align: left !important;
  }

  .filterInputText {
    max-width: 215px !important;
    background: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
    padding: 0 0 0 4px !important;
  }
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 1px 15px;
  padding-left: 0 !important;
}

#tenantConnectionId option {
  color: #6a6a6a;
}

.subHeadWrap {
  line-height: 35px;
  padding: 0 32px 0px 5px;
}

body select {
  /*width: 100px !important;*/
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: rgba(0, 0, 0, 0.3);
  color: #6a6a6a;
}

h3 {
  padding: 20px 20px 0;
  color: #1a80a8;
  font-size: 24px;
  margin: 0;
  font-family: "GTWalsheimPro-Regular";
  font-weight: 400;
}

.v-toast__item .toast-bgclass {
  background-color: #f16161 !important;
}

.contacts {
  overflow: hidden;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.full-width {
  width: calc(100% - 40px);
}

//form basic designs follwed in the application are taken for our form
#addModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#addModal___BV_modal_body_ {
  color: #1dd8f6;
}

.form-control {
  color: #6a6a6a;
}

#addModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

.modal-header {
  background-color: #f7f7f7;
  padding:12px 15px;
  align-items:center;
}

.sub-text {
  color: lightgray;
  font-family: ui-monospace;
  font-size: small;
}

.validation-error {
  color: rgb(207, 110, 110);
  margin-left: 10px;
  margin-top: 10px;
  font-size: 12px;
}

.add-Btn {
  cursor: pointer;
}

.in-valid {
  border-color: #dc1414 !important;
}

.valid {
  border-color: #fff !important;
}

.actionBtn.clientShowBtn.btn-secondary.canTo {
  border-radius: 5px;
  min-width: 60px;
  text-align: center !important;
  display: block;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 16px;
  margin: 5px 0;
}

.edit-form-container {
  max-height: 350px;
  overflow-y: auto;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0px 10px 2px;
  padding: 10px 7px !important;
  max-width: 334px;
  border-radius:5px;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}

.valid{
    border-color: #ebebeb !important;
}
::v-deep .custom-control-label{
  color:#6a6a6a;
}
::v-deep .addTextModalContainer{
  margin-top:400px !important;
  width:20%
}
.invalidTextMessage{
  color:#dc1414;
  margin-top: 10px;
  margin-bottom: 10px;
}
.icon-container{
  margin-left:10px ;
  margin-top: 30px;
  font-size: 20px;
  color:#6a6a6a
}

</style>
